import React , { useEffect } from 'react';
import logomarca from './img/logomarca.png';
import './App.css'; // Importando o arquivo de estilo

const App = () => {
  useEffect(() => {
    // Redireciona para a página externa após 3 segundos
    const timer = setTimeout(() => {
      window.location.href = 'https://bebilogo.sumupstore.com/'; // Redirecionando para a página externa
    }, 3000);

    return () => clearTimeout(timer); // Limpa o timer se o componente for desmontado
  }, []);

  return (
    <div className="container">
      <div className="centro">
        <img 
          src={logomarca} 
          alt="Imagem no Layout" 
          style={{ borderRadius: '8px', width: '280px' }} 
        />
      </div>
    </div>
  );
};

export default App;
